import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { UBISOFT_CONNECT_PLATFORM_TYPES } from 'modules/ubisoft-connect-service/constants';

import IconPC from '!raw-loader!./platform-pc_logo.svg';
import IconXBL from '!raw-loader!./platform-xbox_logo.svg';
import IconXSX from '!raw-loader!./platform-xsx_logo.svg';
import IconPSN from '!raw-loader!./platform-ps4_logo.svg';
import IconPS5 from '!raw-loader!./platform-ps5_logo.svg';
import IconAndroid from '!raw-loader!./platform-android_logo.svg';
import IconSwitch from '!raw-loader!./platform-switch_logo.svg';
import IconSteamvr from '!raw-loader!./platform-steamvr_logo.svg';
import IconIOS from '!raw-loader!./platform-ios_logo.svg';
import IconMobile from '!raw-loader!./platform-mobile_logo.svg';
import IconWeb from '!raw-loader!./platform-web_logo.svg';
import IconOculusvr from '!raw-loader!./platform-oculusvr_logo.svg';
import IconStadia from '!raw-loader!./platform-stadia_logo.svg';
import IconEpic from '!raw-loader!./platform-epic_logo.svg';
import IconLuna from '!raw-loader!./platform-luna_logo.svg';

export default {
    [UBISOFT_CONNECT_PLATFORM_TYPES.UPLAY]: IconPC,
    [UBISOFT_CONNECT_PLATFORM_TYPES.XBL]: IconXBL,
    [UBISOFT_CONNECT_PLATFORM_TYPES.PSN]: IconPSN,
    [UBISOFT_CONNECT_PLATFORM_TYPES.SWITCH]: IconSwitch,
    [UBISOFT_CONNECT_PLATFORM_TYPES.WEB]: IconWeb,
    [UBISOFT_CONNECT_PLATFORM_TYPES.MOBILE]: IconMobile,
    [UBISOFT_CONNECT_PLATFORM_TYPES.IOS]: IconIOS,
    [UBISOFT_CONNECT_PLATFORM_TYPES.ANDROID]: IconAndroid,
    [UBISOFT_CONNECT_PLATFORM_TYPES.OCULUSVR]: IconOculusvr,
    [UBISOFT_CONNECT_PLATFORM_TYPES.STEAMVR]: IconSteamvr,
    [String(PLATFORM_TYPES.STADIA).toLowerCase()]: IconStadia,
    [UBISOFT_CONNECT_PLATFORM_TYPES.EPIC]: IconEpic,
    [String(PLATFORM_TYPES.XSX).toLowerCase()]: IconXSX,
    [String(PLATFORM_TYPES.PS5).toLowerCase()]: IconPS5,
    [String(PLATFORM_TYPES.LUNA).toLowerCase()]: IconLuna,
};
